import axios from "axios";
import {
  FETCH_DATA_FAILURE,
  FETCH_DATA_REQUEST,
  FETCH_DATA_SUCCESS,
} from "../store/actionTypes";
import { encrypted } from "../utils/Utility";

export const fetchDataRequest = (api) => ({
  type: FETCH_DATA_REQUEST,
  api,
});

export const fetchDataSuccess = (api, data) => ({
  type: FETCH_DATA_SUCCESS,
  api,
  payload: data,
});

export const fetchDataFailure = (api, error) => ({
  type: FETCH_DATA_FAILURE,
  api,
  payload: error,
});

const createConfig = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
};

export const fetchData = (url, api, body = null) => {
  return (dispatch) => {
    dispatch(fetchDataRequest(api));
    const config = createConfig();

    let request;

    if (body) {
      request = axios.post(url, body, config);
    } else {
      request = axios.get(url, config);
    }

    request
      .then((response) => {
        const Data = response.data.encryptedBody;
        dispatch(fetchDataSuccess(api, JSON.parse(encrypted.decrypt(Data))));
      })
      .catch((error) => {
        dispatch(fetchDataFailure(api, error));
      });
  };
};

export const postData = (url, api, body = null) => {
  return (dispatch) => {
    dispatch(fetchDataRequest(api));
    const config = createConfig();
    let request = axios.post(url,body ,config);
    request
      .then((response) => {
        const Data = response.data.encryptedBody;
        dispatch(fetchDataSuccess(api, JSON.parse(encrypted.decrypt(Data))));
      })
      .catch((error) => {
        dispatch(fetchDataFailure(api, error));
      });
  };
};

// export const fetchData = (url, api, body = null) => {
//   return (dispatch) => {
//     dispatch(fetchDataRequest(api));

//     const config = createConfig();

//     let request;

//     if (body) {
//       const encryptedBody = {
//         encryptedBody: encrypted.encrypt(JSON.stringify(body)),
//       };
//       request = axios.post(url, encryptedBody, config);
//     } else {
//       request = axios.get(url, config);
//     }

//     request
//       .then((response) => {
//         const decryptedData = JSON.parse(encrypted.decrypt(response.data.encryptedBody));
//         dispatch(fetchDataSuccess(api, decryptedData));
//       })
//       .catch((error) => {
//         dispatch(fetchDataFailure(api, error));
//       });
//   };
// };

// Generic function to fetch data for any given API
export const createFetchAction = (api) => {
  return (url) => (dispatch) => {
    fetchData(url, api)(dispatch);
  };
};

// Action to fetch and handle POST requests
export const createPostAction = (api) => {
  return (url, body) => (dispatch) => {
    postData(url, api, body)(dispatch);
  };
};

// Example usage:
export const fetchLoggedInDetails = createFetchAction("loggedInDetails");
export const postGenerateDossier = createFetchAction("generateDossierDetails");
export const fetchCountry = createFetchAction("countryDetails");
export const fetchProduct = createPostAction("productDetails");
export const fetchRegiObjective = createPostAction("regiObjectiveDetails");
export const fetchBinderSelection = createPostAction("binderSelectionDetails");
export const fetchLook = createPostAction("lookDetails");
export const fetchVerifyToken = createFetchAction("verifyTokenDetails");
